// Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyCPXHdeN9jePvKLP7sp3IDosnANz_l8fbo",
  authDomain: "codecandy-copyugc.firebaseapp.com",
  databaseURL: "https://codecandy-copyugc-default-rtdb.firebaseio.com",
  projectId: "codecandy-copyugc",
  storageBucket: "codecandy-copyugc.firebasestorage.app",
  messagingSenderId: "14357222862",
  appId: "1:14357222862:web:d47248874692174516479f",
  measurementId: "G-FE4VMBFJKG"
};

